import React, { useState, useEffect } from "react";
import {
	Box,
	Rating,
	IconButton,
	Grid,
	Card,
	CardContent,
	CardHeader,
	AppBar,
	Tabs,
	Tab,
	Stack,
	Pagination,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import ThumbsUpIcon from "@mui/icons-material/ThumbUp";
import ThumbsDownIcon from "@mui/icons-material/ThumbDown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import ApnaSelect from "components/ApnaSelect/location";
import ApnaSelec2 from "components/ApnaSelect";
import GradientLineChart from "examples/Charts/BarCharts/VerticalBarChart copy 2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftTypography from "components/SoftTypography";
import { baseURL } from "utils/api";
import toast from "react-hot-toast";
import SoftBadge from "components/SoftBadge";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { AllInboxOutlined, ApprovalOutlined, ArrowDownward, CalendarMonth, CalendarViewDayRounded, Download, PendingActionsOutlined, StarBorderOutlined } from "@mui/icons-material";
import Loading from "components/ApnaLoading";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { getLocationData } from "api/commonSlice";
import CustomDate from "./customDate";
import NotFound from "components/notFound";
import SoftInput from "components/SoftInput";
import useMediaQuery from "@mui/material/useMediaQuery";


const ReviewSection = () => {

	const matches = useMediaQuery("(max-width:600px)");
	const userTheme = useSelector((state) => state.commonSlice.theme);
	const [selectedLocation, setSelectedLocation] = useState("default");
	const [reviews, setReviews] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loadingDashboard, setLoadingDashboard] = useState(true);
	const id = localStorage.getItem("id");
	const [reviewsDashboard, setReviewsDashboard] = useState({});
	const [tabsOrientation, setTabsOrientation] = useState("horizontal");
	const [tabValue, setTabValue] = useState(0);
	const [startCount, setStartCount] = useState(null);
	const locations = useSelector((state) => state.commonSlice?.locations);
	const dispatch = useDispatch();
	const filterLocation = useSelector((state) => state.searchSlice?.filterLocation);
	const [allLocations, setAllLocations] = useState([]);
	const [show, setShow] = useState(false)
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [dateValue, setDateValue] = useState('');
	const [searchQuery, setSearchQuery] = useState('');
	const [totalPage, setTotalPage] = useState(1);
	const [page, setPage] = useState(1);
	const [thumb, setThumb] = useState('thumbs_up')

	const [gradientLineChartData, setGradientLineChartData] = useState({
		labels: [],
		datasets: [
			{
				label: "Reviews Rating %",
				color: "info",
				data: [],
			},
		],
	});

	const [ratingsData, setReviewsData] = useState({
		5: 0,
		4: 0,
		3: 0,
		2: 0,
		1: 0
	});

	useEffect(() => {
		dispatch(getLocationData());
	}, []);

	const handleLocationChange = (event) => {
		setSelectedLocation(event.target.value);
	};

	useEffect(() => {
		if (locations) {
			setAllLocations([]);
			locations &&
				locations.length > 0 &&
				locations.map((location) => {
					setAllLocations((prev) => [...prev, { _id: location?._id, name: location?.locationName }]);
				})
		}
	}, [locations]);


	useEffect(() => {
		// A function that sets the orientation state of the tabs.
		function handleTabsOrientation() {
			return window.innerWidth < breakpoints.values.sm
				? setTabsOrientation("vertical")
				: setTabsOrientation("horizontal");
		}
		window.addEventListener("resize", handleTabsOrientation);
		handleTabsOrientation();
		return () => window.removeEventListener("resize", handleTabsOrientation);

	}, [tabsOrientation]);

	const handleSetTabValue = (event, newValue) => setTabValue(newValue);

	const fetchReviews = async (start, ev, locationId, startDate, endDate, search, page) => {
		setLoading(true);
		fetch(`${baseURL}getAllReviews/${id}?page=${page}&businessId=${locationId}&${start != null ? `starRating=${start}&` : ''}status=${ev == 0 ? "all" : ev == 1 ? 'PENDING' : ev == 2 ? 'APPROVED' : ev == 3 ? 'REJECTED' : "all"}${startDate != null ? `&startDate=${startDate}` : ''}${endDate != null ? `&endDate=${endDate}` : ''}${search.length > 0 ? `&searchData=${search}` : ''}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${localStorage.getItem("token")}`,
			},
		}).then((res) => res.json())
			.then((resp) => {
				setLoading(false);
				if (resp.success) {
					setReviews(resp.data);
					setTotalPage(resp?.totalPages);
				} else {
					setReviews([]);
					setTotalPage(1);
				}
			});
	};

	const fetchReviewDashboard = (locationId, startDate, endDate) => {
		setLoadingDashboard(true);
		fetch(`${baseURL}star/ratingDetails/merchant/${id}?businessId=${locationId}&startDate=${startDate == null ? null : new Date(startDate).toISOString().slice(0, 10)}&endDate=${endDate == null ? null : new Date(endDate).toISOString().slice(0, 10)}`)
			.then(res => res.json())
			.then(data => {
				if (data.success) {
					setReviewsDashboard(data?.data);
					setReviewsData({
						5: data?.data?.Five_Star_Percentage,
						4: data?.data?.Four_Star_Percentage,
						3: data?.data?.Three_Star_Percentage,
						2: data?.data?.Two_Star_Percentage,
						1: data?.data?.One_Star_Percentage
					});
				} else {
					setReviewsDashboard({});
					setReviewsData({
						5: 0,
						4: 0,
						3: 0,
						2: 0,
						1: 0
					});
				}
				setLoadingDashboard(false);
			}).catch(err => {
				toast.error(err.message || 'Something went wrong');
			});
	};
	const fetchReviewDashboardData = (locationId, startDate, endDate, thumb) => {
		setLoadingDashboard(true);
		fetch(`${baseURL}reviewTagBarChartData/${id}?type=${thumb}&businessId=${locationId}&startDate=${startDate == null ? null : new Date(startDate).toISOString().slice(0, 10)}&endDate=${endDate == null ? null : new Date(endDate).toISOString().slice(0, 10)}`)
			.then(res => res.json())
			.then(data => {
				console.log(data, "dat323423a")
				if (data.success) {
					const labels = data?.data?.map((item) => item?.name);
					const values = data?.data?.map((item) => item?.value);
					setGradientLineChartData({
						labels: labels,
						datasets: [
							{
								label: "Percentage %",
								color: "info",
								data: values,
							},
						],
					});
				} else {
					setGradientLineChartData({
						labels: [],
						datasets: [
							{
								label: "Percentage %",
								color: "info",
								data: [],
							},
						],
					});
				}
				setLoadingDashboard(false);
			}).catch(err => {
				toast.error(err.message || 'Something went wrong');
			});
	};

	useEffect(() => {
		fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, searchQuery, 1);
		fetchReviewDashboard(selectedLocation, startDate, endDate);
		fetchReviewDashboardData(selectedLocation, startDate, endDate, thumb);
	}, [startCount, tabValue, selectedLocation, dateValue]);


	const handleUpdateReview = async (status, id) => {

		fetch(`${baseURL}update/review/${id}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${localStorage.getItem("token")}`,
			},
			body: JSON.stringify({
				status: status,
			}),
		}).then((res) => res.json())
			.then((resp) => {
				if (resp.success) {
					toast.success(resp.message);
					fetchReviews(startCount, tabValue, filterLocation, startDate, endDate, searchQuery, 1);
				} else {
					toast.error(resp.message);
				}
			}).catch((err) => {
				toast.error(err.message || 'Something went wrong');
			});
	};

	const handleChangeDate = (event) => {
		if (event.target.value === "") {
			setDateValue(null);
			setStartDate(null);
			setEndDate(null);
		}
		if (event.target.value === "Today") {
			setStartDate(new Date().toISOString());
			setEndDate(new Date(new Date().setDate(new Date().getDate() + 1)).toISOString());
			setDateValue(event.target.value);
		}
		if (event.target.value === "This Week") {
			const currentDate = new Date(); // Today
			const pastWeekDate = new Date(currentDate);
			pastWeekDate.setDate(currentDate.getDate() - 6); // Last 7 days including today

			setStartDate(pastWeekDate.toISOString());
			setEndDate(currentDate.toISOString());
			setDateValue(event.target.value);
		}

		if (event.target.value === "This Month") {
			const currentDate = new Date(); // Today
			const pastMonthDate = new Date(currentDate);
			pastMonthDate.setDate(currentDate.getDate() - 29); // Last 30 days including today

			setStartDate(pastMonthDate.toISOString());
			setEndDate(currentDate.toISOString());
			setDateValue(event.target.value);
		}

		if (event.target.value === "This Year") {
			const currentDate = new Date(); // Today
			const pastYearDate = new Date(currentDate);
			pastYearDate.setDate(currentDate.getDate() - 364); // Last 365 days including today

			setStartDate(pastYearDate.toISOString());
			setEndDate(currentDate.toISOString());
			setDateValue(event.target.value);
		}

		console.log(event.target.value, 'event.target.value')

		if (event.target.value === "Custom") {
			setShow(true);
		}
	};



	const onSearchChange = (e) => {
		const value = e.target.value;
		setSearchQuery(value);
		fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, value, 1);
	};


	const handlePageChange = (page) => {
		setPage(page);
		fetchReviews(startCount, tabValue, selectedLocation, startDate, endDate, searchQuery, page);
	}

	const handleFilterChange = (event) => {
		setThumb(event.target.value);
		fetchReviewDashboardData(selectedLocation, startDate, endDate, event.target.value);
	};


	return (

		<DashboardLayout>
			<DashboardNavbar />

			<CustomDate show={show} setDateValue={setDateValue} setShow={setShow} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />

			<SoftBox p={2}>
				<Grid container spacing={1} >
					<Grid item xs={12} md={5}>
						<SoftBox mb={2}>
							<SoftTypography variant="h6">Filters </SoftTypography>
							<SoftBox
								sx={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<SoftBox mr={2}>
									<ApnaSelect
										origin="Location"
										value={selectedLocation}
										options={allLocations}
										onChange={handleLocationChange}
									/>
								</SoftBox>
								<SoftBox mr={2}>
									<ApnaSelec2
										origin="date"
										value={dateValue}
										options={[{ name: "Today" }, { name: "This Week" }, { name: "This Month" }, { name: "This Year" }, { name: "Custom" }]}
										onChange={handleChangeDate}
									/>
								</SoftBox>

							</SoftBox>
						</SoftBox>
						<SoftBox
							sx={{
								display: "flex",
								// flexWrap: "wrap",
								marginTop: 2,
								marginBottom: 2,
								width: "100%"
							}}
						>
							{
								loadingDashboard ? <Skeleton width={200} height={200} /> :

									<Card sx={{ marginRight: 3 }} className="glassmorphism-card">
										<SoftBox py={3} px={2} m={1} >
											<SoftBox sx={{ display: "flex", alignItems: 'center' }}>
												<IconButton>
													<ThumbsUpIcon sx={{ color: "#4caf50" }} />
												</IconButton>
												<ArrowUpwardIcon color="success" />
												<SoftTypography variant="h6" color="success">
													{(reviewsDashboard?.Thumbs_Up_Percentage || 0) + "% "}
												</SoftTypography>{" "}
											</SoftBox>
											<SoftTypography variant="h6" >
												Positive Review ({reviewsDashboard?.Thumbs_Up || 0})
											</SoftTypography>
											<SoftTypography variant="caption" sx={{ display: "flex", alignItems: 'center' }}>
												{" " + (reviewsDashboard?.periodText || 'N/A')}
											</SoftTypography>
										</SoftBox>
									</Card>
							}
							{
								loadingDashboard ? <Skeleton width={200} height={200} /> :
									<Card className="glassmorphism-card">
										<SoftBox py={3} px={2} m={1} >
											<SoftBox sx={{ display: "flex", alignItems: "center" }}>
												<IconButton>
													<ThumbsDownIcon sx={{ color: "#f44336" }} />
												</IconButton>
												<ArrowDownward color="error" />     <SoftTypography variant="h6" color="error"> {reviewsDashboard?.Thumbs_Down_Percentage} </SoftTypography>  {" "}
											</SoftBox>
											<SoftTypography variant="h6" >
												Negative Review ({reviewsDashboard?.Thumbs_down || 0})
											</SoftTypography>
											<SoftTypography variant="caption" sx={{ display: "flex", alignItems: "center" }}>
												{reviewsDashboard?.periodText || 'N/A'}
											</SoftTypography>
										</SoftBox>
									</Card>
							}
						</SoftBox>

						<SoftBox mr={matches ? 0 : 2} mt={1}>
							<Card className="glassmorphism-card">
								<SoftBox ml={1} p={2} className="ratings-chart">
									<SoftBox my={1}>
										<SoftTypography>Reviews <StarBorderOutlined />
										</SoftTypography>
									</SoftBox>
									{Object.keys(ratingsData)
										.sort((a, b) => b - a) // Sort ratings from 5 to 1
										.map((rating) => (
											<div key={rating} className="rating-row">
												<SoftTypography variant="caption" className="rating-label">{rating}.0</SoftTypography>
												<div className="rating-bar">
													<div
														className="rating-fill"
														style={{ width: `${ratingsData[rating]}%` }}
													></div>
												</div>
											</div>
										))}
								</SoftBox>
							</Card>
						</SoftBox>
					</Grid>

					{/* Submit Review */}
					<Grid item xs={12} lg={7}>
						<GradientLineChart
							title={`Response (${reviewsDashboard?.Total || 0})`}
							description={
								'Reviewee answer'
							}
							height="20.25rem"
							chart={gradientLineChartData}
							option={[{ name: "Thumbs Up", _id: 'thumbs_up' }, { name: "Thumbs Down", _id: 'thumbs_down' }]}
							handleFilterChange={handleFilterChange}
							selectedFilter={thumb}
						/>
					</Grid>

				</Grid>

				{/* Reviews List */}
				<Box sx={{ marginTop: 5, }}>

					<Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
						<AppBar position="static" sx={{ borderRadius: '8px' }}>
							<Tabs
								orientation={tabsOrientation}
								value={tabValue}
								onChange={handleSetTabValue}
								sx={{
									background: userTheme === "dark" ? "rgba(0, 0, 0, 0.8) !important" : "rgba(124, 124, 124, 0.1) !important",
									color: userTheme === "dark" ? "white !important" : "black !important",
									"& .MuiTab-root": {
										color: userTheme === "dark" ? "white" : "gray", // Unselected tab color
										textTransform: "none", // Optional: Keeps the text casing as provided
									},
									"& .Mui-selected": {
										backgroundColor: userTheme === "dark" ? "rgba(0, 0, 0, 0.8) !important" : "#fff !important",
										color: userTheme === "dark" ? "white !important" : "black !important", // Selected tab text color
										borderRadius: '5px !important'
									},
									"& .MuiTab-root:not(.Mui-selected)": {
										color: userTheme === "dark" ? "white" : "gray !important", // Ensure unselected tab text color
									},
									"& .MuiTab-root:hover": {
										backgroundColor: userTheme === "dark" ? "rgba(50, 50, 50, 0.8)" : "rgba(240, 240, 240, 0.8)", // Hover effect for tabs
									},
								}}
							>
								<Tab label="All" icon={<AllInboxOutlined />} />
								<Tab label="Pending" icon={<PendingActionsOutlined />} />
								<Tab label="Published" icon={<AllInboxOutlined />} />
								<Tab label="Rejected" icon={<ApprovalOutlined />} />
							</Tabs>

						</AppBar>
					</Grid>
					<SoftBox>

						<SoftBox sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
							<SoftBox p={2}>
								<SoftTypography variant="h5" gutterBottom color="info">
									Reviews
								</SoftTypography>
								<SoftTypography variant="caption" color="textSecondary">
									*Only customer feedback goes through the approval process. Ratings and Reviews are auto-published.
								</SoftTypography>
							</SoftBox>

							<SoftBox >
								<SoftTypography variant="caption" color="textSecondary">
									Star Ratings
								</SoftTypography>
								<ApnaSelec2
									origin="Star rate"
									value={startCount}
									options={[{ name: "1" }, { name: "2" }, { name: "3" }, { name: "4" }, { name: "5" }]}
									onChange={(e) => setStartCount(e.target.value)}
								/>
							</SoftBox>

							<SoftBox p={2}>

								<SoftInput
									onChange={onSearchChange}
									placeholder="Search here..."
									icon={{ component: "search", direction: "left" }}
								/>

							</SoftBox>
						</SoftBox>

						{loading ? (
							<Loading />
						) : reviews && reviews.length > 0 ? (
							reviews.map((review) => (
								<Card className="glassmorphism-card" key={review?._id} sx={{ mb: 1, borderBottom: 1, borderColor: 'divider', borderRadius: 2 }}>
									<CardHeader
										title={
											<SoftTypography variant="h6" fontWeight="medium">
												{review?.customerUserId?.firstName
													? `${review.customerUserId.firstName} ${review.customerUserId.lastName}`
													: 'N/A'}
											</SoftTypography>
										}
										subheader={
											<SoftBox>
												<SoftTypography variant="caption" color="text.secondary">
													{review?.additionalUserId?.city?.name
														? `${review.additionalUserId.city.name}, `
														: ''}
													{review?.additionalUserId?.state?.name
														? review.additionalUserId.state.name
														: ''}
													{(review?.additionalUserId?.city || review?.additionalUserId?.state) && ' • '}
													<CalendarMonth sx={{ fontSize: 14, verticalAlign: 'middle', mx: 0.5 }} />
													{review?.createdAt
														? new Date(review.createdAt).toLocaleDateString('en-US', {
															year: 'numeric',
															month: 'long',
															day: 'numeric',
														})
														: ''}
												</SoftTypography>

												<SoftBox mt={1} display="flex" alignItems="center" flexWrap="wrap" gap={1}>
													<Rating value={review?.starRating} readOnly size="small" />
													{review?.tags?.map((tag, i) => (
														<SoftBadge key={i} color="info" badgeContent={tag?.name} size="sm" />
													))}
												</SoftBox>
											</SoftBox>
										}
										action={
											<SoftBadge
												variant="gradient"
												circular
												color={
													review?.status === 'PENDING'
														? 'warning'
														: review?.status === 'APPROVED'
															? 'success'
															: review?.status === 'REJECTED'
																? 'error'
																: 'secondary'
												}
												badgeContent={review?.status || 'UNKNOWN'}
												size="lg"
											/>
										}
									/>
									<CardContent>
										<SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>
											<SoftTypography variant="body2">
												<strong>Review:</strong> {review?.comment || 'No Review Text'}
											</SoftTypography>

											{review?.status === 'PENDING' && (
												<SoftBox display="flex" gap={1}>
													<SoftButton
														variant="gradient"
														color="info"
														size="small"
														onClick={() => handleUpdateReview('APPROVED', review?._id)}
													>
														Approve
													</SoftButton>
													<SoftButton
														variant="outlined"
														color="info"
														size="small"
														onClick={() => handleUpdateReview('REJECTED', review?._id)}
													>
														Reject
													</SoftButton>
												</SoftBox>
											)}
										</SoftBox>
									</CardContent>
								</Card>
							))
						) : (
							<NotFound />
						)}


						<Stack spacing={5} m={5} sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
							<Pagination
								onChange={(event, page) => handlePageChange(page)}
								count={totalPage}
								variant="outlined"
								sx={{
									'& .MuiPaginationItem-root': {
										color: 'gray', // Inactive color
										borderColor: "gray"
									},
									'& .Mui-selected': {
										color: '#ffffff', // Active color
										borderColor: "#ffffff",
									},
								}}
								shape="rounded"
							/>
						</Stack>
						{/* <SoftBox m={2} display="flex" gap={2} alignItems='center' justifyContent='center' >
              <SoftButton variant="contained" color="black"
              >

                <img
                  src={require("../../assets/images/xls.png")}
                  alt="excel"
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                
                <SoftBox ml={1} mt={1}>
                  <Download />
                </SoftBox>
              </SoftButton>
              <SoftButton variant="contained" color="black"
              // onClick={exportToPDF}
              >
                <img
                  src={require("../../assets/images/pdff.png")}
                  alt="excel"
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                
                <SoftBox ml={1} mt={1}>
                  <Download />
                </SoftBox>
              </SoftButton>
            </SoftBox> */}
					</SoftBox>

				</Box>
			</SoftBox>
		</DashboardLayout>
	);
};

export default ReviewSection;


